import { render } from "./stockRequest.vue?vue&type=template&id=7c59ba15&scoped=true"
import script from "./stockRequest.vue?vue&type=script&lang=js"
export * from "./stockRequest.vue?vue&type=script&lang=js"

import "./stockRequest.vue?vue&type=style&index=0&id=7c59ba15&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c59ba15"]])

export default __exports__